import React from "react";

const Contact = () => {
    return (
        <div>
            <h1>Contact</h1>
            <div class="text">
                <p class="text-center">For questions, more information and orders,
                    please call us at:</p>

                <h3><div class="text-center mb-4">603-582-8372</div></h3>
                <p class="text-center">Or drop us an email:</p>
                <h3>    <div class="text-center">www.brooklinefirewood@hotmail.com</div></h3>
            </div>
        </div>
    )
};
export default Contact;